import React, { useState } from "react";
import "../../assets/styles/table.css";
import { FiEye, FiEdit2, FiTrash2 } from "react-icons/fi";
import { ICustomer } from "../../types";
import { customerColumns, ROUTES } from "../../constants/constants";
import { useGetCustomerListQuery } from "../../store/api/customerApi";
import Pagination from "rc-pagination";
import { useNavigate } from "react-router-dom";

const getStatusInfo = (status: number) => {
  switch (status) {
    case 0:
      return { text: "Pending", class: "pending" };
    case 1:
      return { text: "Approved", class: "approved" };
    case 2:
      return { text: "Rejected", class: "rejected" };
    default:
      return { text: "Unknown", class: "pending" };
  }
};

const TableCustomer: React.FC<{
  onView?: (row: ICustomer) => void;
  pageNumber: number;
  setTotalCount: (count: number) => void;
  searchValue?: string;
}> = ({ onView, pageNumber, setTotalCount, searchValue = "" }) => {
  const { data: customerData, isLoading: customerLoading } =
    useGetCustomerListQuery({ page: pageNumber, search: searchValue });
  React.useEffect(() => {
    setTotalCount(customerData?.data?.totalCount || 0);
  }, [customerData, setTotalCount]);
  // Filter logic
  const navigate = useNavigate();

  return (
    <div className="tableWrapper">
      <div className="tableHeader">
        <button
          className="addCustomerButton"
          onClick={() => navigate(ROUTES.ADD_EDIT_CUSTOMER)}
        >
          Add Customer
        </button>
      </div>
      <table className="table">
        <thead>
          <tr>
            {customerColumns.map((col) => (
              <th key={col.key} data-column={col.key}>
                {col.label}
              </th>
            ))}
            <th></th>
          </tr>
        </thead>
        <tbody className="tableBodyWrapper">
          {customerLoading ? (
            <tr>
              <td colSpan={customerColumns.length + 1}>Loading...</td>
            </tr>
          ) : (
            customerData?.data?.users.map((row: ICustomer) => (
              <tr key={row.id}>
                {customerColumns.map((col) => (
                  <td key={col.key} data-column={col.key}>
                    {col.key === "status" ? (
                      <span
                        className={`status-badge status-${
                          getStatusInfo(Number(row?.status)).class
                        }`}
                      >
                        {getStatusInfo(Number(row?.status)).text}
                      </span>
                    ) : Array.isArray(row[col.key as keyof ICustomer]) ? (
                      "-"
                    ) : (
                      row[col.key as keyof ICustomer] ?? "-"
                    )}
                  </td>
                ))}
                <td className="actionCell">
                  <button
                    className="actionButton"
                    onClick={() => onView?.(row)}
                    title="View"
                  >
                    <FiEye />
                  </button>
                  <button
                    className="actionButton"
                    onClick={() =>
                      navigate(`/add-edit-customer?id=${row.id}&operation=edit`)
                    }
                    title="Edit"
                  >
                    <FiEdit2 />
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableCustomer;
